import { useQuery } from "@tanstack/react-query";
import instance from "services/axiosServices";
import leadsWebEnviroment from "../../../utils/leadsWebEnviroment";

export function useTemperaturasLead() {
  const fetchData = async () => {
    const TEMPERATURAS_LEAD = `${leadsWebEnviroment}/mobile/temperaturas-lead/v1`;
    const response = await instance.get(TEMPERATURAS_LEAD);
    const dataWithPagination = {
      data: response?.data?.data,
      pagination: response?.data?.pagination,
    };
    return dataWithPagination;
  };
  const query = useQuery({
    queryFn: () => fetchData(),
    refetchOnWindowFocus: false,
    queryKey: ["listar_temperaturas_lead"],
    refetchOnMount: false,
    enabled: false,
  });
  return query;
}
